import { useCallback, useState, useContext } from 'react';
import { loginRefresh } from '../helper/sso';
import { AppContext } from '../provider/AppContextProvider';

export function sendMessageToApp(value: any, debugLog: any) {
  if(debugLog) {
    debugLog("* sendMessageToApp " +  JSON.stringify({a: value != null, b: false, c: value}))
  }
  if(window.setUserState) {
    window.setUserState(value != null, false)
  }
}

export function useUser() {
  const { user, setUser, debugLog } = useContext(AppContext);

  const setUserExt = useCallback((value: any) => {
    debugLog("* setUserExt " + JSON.stringify(value))
    setUser(value)
    sendMessageToApp(value, debugLog)
    
  }, [setUser])

  return [user, setUserExt as any];
}

export function useUserValidator(user: any, setUser: any) {
  const [updating, setUpdating] = useState(false)
  const { debugLog } = useContext(AppContext);

  function addHoursToDate(date: Date): Date {
    let dateHours = new Date(new Date(date).setHours(date.getHours() + 2));
    return dateHours
  }

  const validate = useCallback(async () => {
    if(!updating) {
      if(user && user.decoded && user.decoded.exp) {
        if(new Date(user.decoded.exp * 1000) < addHoursToDate(new Date())) {
          setUpdating(true)
          const data = await loginRefresh(user.refreshToken)
          if (data.tokenId && data.refreshToken && data.decoded) {
            const updatedUser = {
              ...user,
              tokenId: data.tokenId,
              refreshToken: data.refreshToken,
              decoded: data.decoded
            }
            debugLog("* validate setUser 1 " + JSON.stringify(updatedUser))
            setUser(updatedUser)
          }
          else {
            debugLog("* validate setUser 2 null");
           setUser(null)
          }
          setUpdating(false)
        }
        // else {
        //   debugLog("* validate else 1", user)
        //   sendMessageToApp(user)
        // }
      }
      // else {
      //   debugLog("* validate else 2", user)
      //   sendMessageToApp(user)
      // }
    }
  }, [user, setUser, updating, setUpdating])

  return [validate];
}

